import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Layout } from "./components/Layout";
import { RequireAuth } from "./components/RequireAuth";
import { useContentProtection } from "./hooks/useContentProtection";

import Welcome from "./pages/Welcome";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Story from "./pages/Story";
import Perfumer from "./pages/Perfumer";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import Account from "./pages/Account";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Register from "./pages/Register";
import Admin from "./pages/Admin";
import InfoPage from "./pages/InfoPage";
import PaymentSuccess, { PaymentCancel } from "./pages/PaymentStatus";
import Experiments from "./pages/Experiments";

function App() {
  useContentProtection();
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#0F0F0F", border: "1px solid #262421", color: "#F2EBE1", borderRadius: 0 } }} />
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route element={<Layout />}>
                {/* Public pages */}
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/shipping" element={<InfoPage page="shipping" />} />
                <Route path="/privacy" element={<InfoPage page="privacy" />} />
                <Route path="/terms" element={<InfoPage page="terms" />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/experiments" element={<Experiments />} />
                {/* Members-only pages */}
                <Route element={<RequireAuth />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="/story" element={<Story />} />
                  <Route path="/perfumer" element={<Perfumer />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
                  <Route path="/account" element={<Account />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
